<template>
  <div class="products-main">
    <div class="products-content-1">{{ zh === 'ja' ? '製品情報' : 'Products' }}</div>
    <div class="products-line"></div>
    <div class="products-content-2">
      <div v-for="item in tableList" :key="item.name" :class="active.name === item.name ? 'menu active-menu' : 'menu'" @click="toggle(item)">
        <div>{{ item.top + ' ' + item.bottom }}</div>
      </div>
    </div>
    <div class="products-content-3">
      <img :src="item.url" alt="" style="width: 300px" v-for="item in tableList" :key="item.name" v-show="active.name === item.name">
    </div>
  </div>
</template>

<script>
export default {
  name: "mProducts",
  components: {},
  props: {},
  computed: {},
  watch: {
    "$route.query.zh": {
      immediate: true, // 第一次的数据，也要当做是一种变化
      // 处理函数（不能修改名字） handler('新的值'，'旧的值')
      handler(new_value, old_value) {
        this.zh = new_value;
        if (this.zh === 'ja') {
          this.tableList = this.tableListJa;
        } else {
          this.tableList = this.tableListEn;
        }
      },
    },
  },
  data() {
    return {
      active: null,
      tableList: [],
      tableListEn: [
        { name: 0, top: 'General', bottom: 'Information', url: require('../../assets/General Information.png')},
        { name: 1, top: 'Inverter', bottom: 'Specification', url: require('../../assets/Inverter Specification.png')},
        { name: 2, top: 'Battery', bottom: 'Specification', url: require('../../assets/Battery Specification.png')},
        { name: 3, top: 'PV', bottom: 'Specification', url: require('../../assets/PV Specification.png')},
      ],
      tableListJa: [
        { name: 0, top: '一般', bottom: '情報', url: require('../../assets/General Information.png')},
        { name: 1, top: 'インバーターの', bottom: '仕様', url: require('../../assets/Inverter Specification.png')},
        { name: 2, top: 'バッテリーの', bottom: '仕様', url: require('../../assets/Battery Specification.png')},
        { name: 3, top: 'PVの', bottom: '仕様', url: require('../../assets/PV Specification.png')},
      ],
      zh: '',
    }
  },
  methods: {
    testAxios() {
      this.axios({
        method: 'get',//post
        url: 'api/',
        params: {}//data: {}
      }).then((response) => {
        const result = response.data;
        if (result.code === 0) {
        } else {
        }
      })
    },
    toggle(item) {
      this.active = item;
    },
  },
  created() {
    this.active = this.tableList[0];
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
  .products-main {
    width: 100%;
    height: 900px;
    background: url('../../assets/m/products-bg.png') no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;

    .products-content-1 {
      margin-top: 102px;
      width: 294px;
      height: 41px;
      float: left;

      font-family: 'PP Neue Machina',serif;
      font-style: normal;
      //font-weight: 800;
      font-size: 38px;
      line-height: 109%;
      color: #FFFFFF;
    }

    .products-line {
      margin-top: 16px;
      width: 294px;
      height: 1px;
      background: linear-gradient(90deg, #3CD3F7 -4.11%, #16F4A7 100.58%);
    }

    .products-content-2 {
      margin-top: 29px;
      width: 330px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;

      .active-menu {
        background: rgba(#FFFFFF, 0.3);
        border-radius: 13.5px;
      }

      .menu {
        margin-top: 10px;
        width: 155px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;

        div {
          //width: 155px;
          height: 14px;
          font-family: 'Poppins-SB',serif;
          //padding: 6px 12px;
          font-style: normal;
          //font-weight: 600;
          font-size: 12px;
          line-height: 109%;
          color: #FFFFFF;
        }
      }
    }

    .products-content-3 {
      margin-top: 39px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/m/products.vue